import React from "react";
import LoadingScreen from "../../../shared/components/LoadingScreen";
import { useEditProduct } from "./products/edit-product/hooks/useEditProduct";
import { useFormHandlers } from "./products/edit-product/hooks/useFormHandlers";
import EditProductFields from "./products/edit-product/components/EditProductFields";
import EditProductActions from "./products/edit-product/components/EditProductActions";
import { ModalWrapper } from "src/shared/components/ModalWrapper";
import { EditProductProps } from "src/shared/services/interfacev2";

const EditProduct: React.FC<EditProductProps> = (props) => {
  const editHook = useEditProduct(props);
  const formHandlers = useFormHandlers({
    formData: editHook.formData,
    handleInputChange: editHook.handleInputChange,
    removeEmojis: editHook.removeEmojis,
    formatAmount: editHook.formatAmount,
  });

  const isUpdateEnabled = editHook.hasChanges && editHook.isFormValid && !editHook.isLoading;

  // ✅ Use null when not open
  if (!props.open) return null;

  return (
    <ModalWrapper title="Edit Product" onClose={props.onClose} showCloseButton width="max-w-xl">
      <div className="space-y-6">
        <EditProductFields
          {...{
            ...editHook,
            ...formHandlers,
            businessType: props.businessType,
            getCategoryInitials: editHook.getCategoryInitials,
            updateProductNameWithCategory: editHook.updateProductNameWithCategory,
          }}
        />

        <EditProductActions onClose={props.onClose} onUpdate={editHook.handleUpdate} isUpdateEnabled={isUpdateEnabled} />
      </div>

      {editHook.isLoading && <LoadingScreen />}
      {/* <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick pauseOnHover /> */}
    </ModalWrapper>
  );
};

export default EditProduct;
